var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{staticClass:"textarea",attrs:{"label":_vm.label}},[_c('el-input',{attrs:{"value":_vm.value,"type":"textarea","name":"name"},on:{"input":function (val) { return _vm.$emit('input', val); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }